#import "../fragments/ctct-contact.graphql"

query GetCtctContacts($entityId: ID!) {
    coreEntity(id: $entityId) {
        id
        primaryCtctContact {
            ...CtCtContact
        }
        ctctContacts {
            ...CtCtContact
        }
    }
}
